enum AppMode {
  FULL = 'full',
  CONTACT = 'contact',
  LINK = 'link',
  FACT_SET = 'factSet',
  ADMIN = 'admin',
}

export default AppMode;
